{
  "ariaLabel": "FAA mapping tabs",
  "tabs": {
    "aircraftMapping": "Aircraft Mapping",
    "tailManualAdd": "Tail Manual Add",
    "blacklist": "Blacklist",
    "tailRequests": "Tail Requests",
    "pendingApprovals": "Pending Approvals"
  },
  "tailMappingTab": {
    "title": "Manually Add FAA Tail Number",
    "description": "Add a new tail number to the FAA database and map it to an aircraft type. The tail will be immediately available for use in bulk uploads and scheduling.",
    "form": {
      "labels": {
        "tailNumber": "Tail Number",
        "manufacturer": "Manufacturer",
        "model": "Model",
        "aircraft": "Aircraft Type"
      },
      "placeholders": {
        "tailNumber": "N12345",
        "manufacturer": "CESSNA",
        "model": "172S"
      },
      "buttons": {
        "add": "Add Tail Number",
        "adding": "Adding..."
      },
      "validation": {
        "tailNumberRequired": "Tail number is required",
        "tailNumberFormat": "Tail number must contain only letters, numbers, and hyphens",
        "tailNumberLength": "Tail number must be between 2 and 10 characters",
        "manufacturerRequired": "Manufacturer is required",
        "manufacturerLength": "Manufacturer must be between 2 and 100 characters",
        "modelRequired": "Model is required",
        "modelLength": "Model must be between 1 and 100 characters",
        "aircraftRequired": "Please select an aircraft type"
      }
    },
    "recentlyAdded": {
      "title": "Recently Added Tail Numbers",
      "emptyState": "No recently added tail numbers",
      "columns": {
        "tailNumber": "Tail Number",
        "manufacturer": "Manufacturer",
        "model": "Model",
        "source": "Source",
        "added": "Added",
        "actions": "Actions"
      },
      "sources": {
        "faaImport": "FAA Import",
        "justNow": "Just now"
      }
    },
    "deleteDialog": {
      "title": "Delete Tail Number",
      "confirmationText": "Are you sure you want to delete tail number <strong>{{tailNumber}}</strong>? This action cannot be undone.",
      "instructionsText": "To confirm deletion, please type <strong>\"delete\"</strong> in the field below:",
      "placeholder": "Type 'delete' to confirm",
      "validationError": "Please type 'delete' exactly",
      "buttons": {
        "cancel": "Cancel",
        "delete": "Delete",
        "deleting": "Deleting..."
      }
    },
    "tooltips": {
      "delete": "Delete tail number {{tailNumber}}"
    },
    "messages": {
      "alreadyExists": "Tail number {{tailNumber}} already exists in the database",
      "permissionDenied": "You don't have permission to add tail numbers",
      "addFailed": "Failed to add tail number: {{message}}",
      "addSuccess": "Successfully added tail number {{tailNumber}}",
      "addSuccessNoMapping": "Added tail number {{tailNumber}}, but aircraft mapping may need manual review",
      "deleteFailed": "Failed to delete tail number: {{message}}",
      "deleteSuccess": "Successfully deleted tail number {{tailNumber}}",
      "error": "Error: {{message}}",
      "unexpectedError": "An unexpected error occurred",
      "unexpectedDeleteError": "An unexpected error occurred while deleting"
    }
  },
  "suggestedAircraftCell": {
    "confidence": {
      "high": "High",
      "medium": "Medium",
      "label": "confidence"
    },
    "score": "Score:",
    "tooltip": {
      "matchDetails": "Match Details",
      "faaInput": "FAA Input (what you're mapping):",
      "suggestedAircraft": "Suggested Aircraft:",
      "modelComparison": "Model Comparison:",
      "faa": "FAA:",
      "airplx": "AirPlx:",
      "legend": {
        "match": "✓ match",
        "case": "~ case",
        "different": "✗ different"
      },
      "whyMatch": "Why this match?",
      "matchQuality": "Match Quality Details:",
      "verifiedMatch": "✓ Verified exact match",
      "manufacturer": "Manufacturer:",
      "model": "Model:",
      "noDirectMatch": "no direct match",
      "scoreLabel": "score",
      "matchLabels": {
        "highMatch": "match ✓",
        "mediumMatch": "match ~",
        "noMatch": "no match ✗"
      },
      "otherMatches": "Other Possible Matches:",
      "clickAlternative": "Click an alternative to select it",
      "instructions": "Click checkmark to approve, or manually select if incorrect"
    },
    "matchReasons": {
      "csvVerified": "This FAA string \"{{matchedString}}\" was previously mapped to this aircraft",
      "csvVerifiedFallback": "Found in verified database mappings",
      "historical": "Similar to previously mapped: \"{{matchedString}}\"",
      "historicalFallback": "Based on historical mapping patterns",
      "combined": "Match found using both database history and fuzzy text matching",
      "traditional": "Match found using fuzzy text matching of manufacturer and model",
      "unknown": "Unknown match method"
    }
  }
}
